export default class Factory {

    // eslint-disable-next-line class-methods-use-this
    getObject() {
        return null
    }
}
